import { Component, OnInit } from '@angular/core';
import {InfoApiService} from '../../../services/rest-api/info.api.service';
import {Router} from '@angular/router';
import {HssResponse} from '../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import {StorageService} from '../../../services/rest-api/storage.service';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  facultyData: any[] = [];
  departmentData: any[] = [];

  constructor(private _info: InfoApiService,
              private router: Router,
              private storage: StorageService,
              private seo: SeoService
              ) {
  }

  ngOnInit(): void {
    this.seo.setMeta('About Faculty of Humanities & Social Sciences','About Humanities, Social Sciences, Vision, mission' )

    this.getDepartments();

    const localFacultydata = this.storage.getData('facultyData');
    this.facultyData = localFacultydata ? JSON.parse(localFacultydata): [];
  }


  // Get departments
  getDepartments(){
    this._info.getDeptListMenu().subscribe (
      (response: HssResponse<any>) => {
        this.departmentData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

}
